// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
import ToastController from "./toast_controller"
application.register("toast", ToastController)
import LoadingButtonController from "./loading_button_controller"
application.register("loading-button", LoadingButtonController)
import ApiTesterController from "./api_tester_controller"
application.register("api-tester", ApiTesterController)
import BatchUnlockController from "./batch_unlock_controller"
application.register("batch-unlock", BatchUnlockController)
import ControlBandOverrideController from "./control_band_override_controller"
application.register("control-band-override", ControlBandOverrideController)
import RebuildControlBandsController from "./rebuild_control_bands_controller"
application.register("rebuild-control-bands", RebuildControlBandsController)
import ExportFormController from "./export_form_controller"
application.register("export-form", ExportFormController)
import IngestionPickerController from "./ingestion_picker_controller"
application.register("ingestion-picker", IngestionPickerController)
import RunProgressController from "./run_progress_controller"
application.register("run-progress", RunProgressController)
